const RouteNames = [
    {id: 1, route: '/admin/mis-recon/reports', name: 'MIS reports'},
    {id: 2, route: '/admin/mis-recon/upload', name: 'upload MIS'},
]

export default RouteNames